/* eslint-disable react/prop-types */
import React from "react";
import { FieldProps } from "formik";
import InputMask from "react-input-mask";

type Props = FieldProps<string>;

export const FormikDob: React.ComponentType<Props> = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched }
}) => (
  <div>
    <InputMask
      placeholder="mm/dd/yyyy"
      className="form-control text-center"
      value={field.value}
      name={field.name}
      onChange={e => {
        if (e.currentTarget.value === "__/__/____") {
          setFieldValue(field.name, undefined);
        } else {
          setFieldValue(field.name, e.currentTarget.value);
        }
      }}
      onBlur={() => setFieldTouched(field.name)}
      mask="nm/ed/zyyy"
      type="tel"
      formatChars={{
        n: "[0-1]",
        m: "[0-9]",
        e: "[0-3]",
        d: "[0-9]",
        z: "[1-2]",
        y: "[0-9]"
      }}
    />
    {touched[field.name] && errors[field.name] && (
      <div className="formik-error">{errors[field.name]}</div>
    )}
  </div>
);

export default FormikDob;
